import { HalamanArticle } from "pages/HalamanArticle/Loadable";
import { HalamanLogin } from "pages/HalamanLogin/Loadable";
import { HalamanLoginAdmin } from "pages/HalamanLoginAdmin/Loadable";
import { HalamanProfileOwner } from "pages/HalamanProfileOwner/Loadable";
import { HalamanRegister } from "pages/HalamanRegister/Loadable";
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function ExternalRedirect({ url }) {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return <p>Redirecting...</p>;
}

export const publicRoutes = [
  {
    path: "/",
    element: <HalamanLogin />,
  },
  {
    path: "/befin-admin",
    element: <HalamanLoginAdmin />,
  },
  {
    path: "/gagal",
    element: <HalamanLogin />,
  },
  {
    path: "/success",
    element: <HalamanLogin />,
  },
  {
    path: "/article",
    element: <HalamanArticle />,
  },
  {
    path: "/refCode/:refCode",
    element: <HalamanRegister />,
  },
  {
    path: "/signup",
    element: <HalamanRegister />,
  },
  {
    path: "/signout",
    element: <HalamanLogin />,
  },
  {
    path: "/profile",
    element: <HalamanProfileOwner />,
  },
  {
    path: "/perencanakeuangan",
    element: <ExternalRedirect url="https://iarfcindonesia.com/workshop/ticket/sertifikasi-perencana-keuangan-gelar-certified-money-manager-16a0d7beea3920" />,
  },

  {
    path: "*",
    element: <h1>404 - Page Not Found</h1>,
  },
];
